// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6fba1e43","455":"456dc920","977":"9ea20811"}[chunkId] + ".chunk.js";
};